import React from "react";
import Box from "@material-ui/core/Box";
import { makeStyles, createMuiTheme, ThemeProvider } from "@material-ui/core/styles";

import { T, FONT_SANS } from "../../constants";

const vipTheme = createMuiTheme({ typography: { fontFamily: FONT_SANS } });

const useStyles = makeStyles({
  root: {
    background: T.bg,
    color: T.fg,
    fontFamily: FONT_SANS,
    margin: -20,
    minHeight: "calc(100% + 40px)",
    padding: 24,
    boxSizing: "border-box",
  },
  inner: { margin: "0 auto" },
  header: {
    borderRadius: 14,
    background: T.primary,
    color: "#fff",
    padding: "20px 28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 32,
    flexWrap: "wrap",
    marginBottom: 24,
  },
  eyebrow: {
    fontSize: 10,
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "0.42em",
    color: "rgba(255,255,255,0.55)",
  },
  title: { margin: "4px 0 0", fontSize: 26, fontWeight: 300, lineHeight: 1 },
  count: { display: "flex", alignItems: "baseline", gap: 10, textAlign: "right" },
  countLabel: {
    fontSize: 10,
    textTransform: "uppercase",
    letterSpacing: "0.3em",
    color: "rgba(255,255,255,0.55)",
  },
  countValue: { fontSize: 18, fontWeight: 500 },
});

export default function VipPageShell({ eyebrow, title, right, maxWidth = 1400, children }) {
  const s = useStyles();
  return (
    <ThemeProvider theme={vipTheme}>
      <Box className={s.root}>
        <div className={s.inner} style={{ maxWidth }}>
          <div className={s.header}>
            <div>
              <div className={s.eyebrow}>{eyebrow}</div>
              <h1 className={s.title}>{title}</h1>
            </div>
            {right}
          </div>
          {children}
        </div>
      </Box>
    </ThemeProvider>
  );
}

export function HeaderCount({ label, value }) {
  const s = useStyles();
  return (
    <div className={s.count}>
      <div className={s.countLabel}>{label}</div>
      <div className={s.countValue}>{value}</div>
    </div>
  );
}
